export const PHILO = 'https://www.philo.com';
export const PHILO_ABOUT_URL = 'https://about.philo.com';
export const PHILO_BLOG_URL = 'https://blog.philo.com';
export const PHILO_PRESS_URL = `${PHILO_ABOUT_URL}/press`;
export const PHILO_TERMS_OF_USE_URL = `${PHILO_ABOUT_URL}/terms`;
export const PHILO_PRIVACY_POLICY_URL = `${PHILO_ABOUT_URL}/privacy`;
export const PHILO_JOBS_URL = 'https://jobs.philo.com';
export const PHILO_CCPA_NOTICE_URL = `${PHILO_PRIVACY_POLICY_URL}/#ccpa`;
export const PHILO_AD_CHOICES_URL = `${PHILO_PRIVACY_POLICY_URL}/#section-4`;
export const PHILO_HELP_URL = 'https://help.philo.com';
export const PHILO_HELP_SIGN_IN_URL = `${PHILO_HELP_URL}/using-philo/sign-in`;
export const PHILO_DO_NOT_SELL_URL = `${PHILO_HELP_URL}/using-philo/do-not-sell`;
export const PHILO_PLAYBACK_PREFERENCE_URL = `${PHILO_HELP_URL}/using-philo/start-beginning-live`;
export const PHILO_SUPPORT_CONTACT_URL = `${PHILO_HELP_URL}/requests`;
export const PHILO_REFER_HELP_LINK = `${PHILO_HELP_URL}/account-billing/referral-program`;
export const PHILO_CONNECT_URL = `${PHILO_HELP_URL}/using-philo/philo-connect`;
export const PHILO_BROWSE_AND_WATCH_URL = `${PHILO_HELP_URL}/using-philo/browse-and-watch`;
export const PHILO_FAST_FORWARD_URL = `${PHILO_HELP_URL}/using-philo/fast-forward`;
export const PHILO_CHANNEL_LINEUP = `${PHILO_HELP_URL}/channels/`;
export const PHILO_NIELSEN_URL = `${PHILO_TERMS_OF_USE_URL}#philo-nielsen`;
export const BASE_HOST = globalThis.window?.location.host || 'www.philo.com';
export const PRIVACY_LINK_TEXT = 'Your Privacy Choices';

enum LegalType {
  TERMS_PRIVACY = 'privacy',
  TERMS_OF_USE = 'termsOfUse',
}

export interface LegalStrings {
  href: string;
  key: string;
  text: string;
}

type LegalLinks = {
  [key in LegalType]: LegalStrings;
};

export const LEGAL_LINKS: LegalLinks = {
  privacy: {
    href: PHILO_PRIVACY_POLICY_URL,
    key: 'privacy',
    text: 'Privacy Policy',
  },
  termsOfUse: {
    href: PHILO_TERMS_OF_USE_URL,
    key: 'terms',
    text: 'Philo Terms of Service',
  },
};
